import React from "react";

import styled from "styled-components";

import conversation from "../assets/svg/04_conversation.svg";
import eye from "../assets/svg/04_eye.svg";
import file from "../assets/svg/04_file.svg";
import graph from "../assets/svg/04_graph.svg";

export const StepsToAssess: React.FC<{}> = () => {
  return (
    <StyledList className="text-white mb-4 pb-4">
      {data.map(({ imgSrc, title, description }, idx) => (
        <StyledRow key={idx}>
          <div className="h-100 w-50 d-inline-block">
            <img
              src={imgSrc}
              width={223}
              height={223}
              className="d-block mx-auto"
            />
          </div>
          <div className="h-100 w-50 d-inline-block px-5">
            <h3 className="h4 text-uppercase">{title}</h3>
            {description}
          </div>
        </StyledRow>
      ))}
    </StyledList>
  );
};

const StyledList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  counter-reset: listCount;
`;

const StyledRow = styled.li`
  position: relative;
  display: flex;
  padding-bottom: 2rem;

  &::before {
    content: counter(listCount);
    counter-increment: listCount;
    position: absolute;
    top: 0;
    left: calc(50% - 1.5rem);
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25em;
    font-weight: 800;
    border: solid 1px ${(p) => p.theme.info};
    border-radius: 50%;
    z-index: 1;
  }
  &:not(:last-of-type)::after {
    content: "";
    position: absolute;
    top: 3rem;
    left: calc(50% - 1px);
    width: 1px;
    height: calc(100% - 3rem);
    background: ${(p) => p.theme.info};
  }
`;

type DataType = {
  imgSrc: any;
  title: string;
  description: JSX.Element;
};

const data: DataType[] = [
  {
    imgSrc: file,
    title:
      "REVIEW EXISTING HEALTH (OR RELATED) POLICIES AND WHAT THEY DO AND DON’T COVER.",
    description: (
      <>
        <p>
          Find out what you already have in place, work out whether it’s
          sufficient and highlight any gaps.
        </p>
        <p>
          For example, you might have a comprehensive alcohol, physical activity
          and healthy eating policy, but not a smoke-free policy, despite having
          a number of smokers on site. You have identified that you need to
          start developing a smoke-free policy that’s in line with current
          legislation.
        </p>
      </>
    ),
  },
  {
    imgSrc: eye,
    title: "OBSERVE AND AUDIT THE WORKPLACE ENVIRONMENT/S",
    description: (
      <>
        <p>
          Observe the workplace environment, see how employees interact with it
          and how this may be affecting health in order to identify
          improvements.
        </p>
        <p>
          For example, 100% of your workforce might be seated behind computers
          all day, with employees only getting up every now and again to collect
          printing, get a cup of tea or use the bathroom. Employees might even
          eat lunch at their desk! How would you alter the environment to
          encourage people to get up out of their seats more?
        </p>
      </>
    ),
  },
  {
    imgSrc: conversation,
    title:
      "REVIEW CURRENT AND PAST HEALTH ACTIVITIES AND ANY EVALUATION INFORMATION.",
    description: (
      <>
        <p>
          Do you know if any activities have already taken place at your
          organisation, and how successful they were? Use this information to
          plan the next event.
        </p>
        <p>
          For example, if a healthy cooking class was carried out, ensure you
          consult with staff on what they thought of it. If you find out quite a
          lot of people attended, that is a great indicator to show staff are
          already motivated to make healthy behaviour changes.
        </p>
      </>
    ),
  },
  {
    imgSrc: graph,
    title:
      "GATHER DEMOGRAPHIC INFORMATION ABOUT YOUR WORKFORCE (E.G. PERCENTAGE OF MEN VS WOMEN, AVERAGE AGE, LANGUAGE SPOKEN, EDUCATION LEVEL ETC)",
    description: (
      <>
        <p>
          If you’re able to collect this information, it can tell you a lot
          about how to best promote your program. Ensuring anonymity for
          employees will help with participation in a survey that seeks to
          gather this type of information.
        </p>
        <p>
          For example, if English is a second language to many employees, you
          would need to tailor your resources and messages to ensure they are
          meeting your employees’ needs.
        </p>
      </>
    ),
  },
];
